"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Banner_1 = __importDefault(require("components/Banner"));
const Card_1 = require("components/base/Card");
const Layout_1 = require("components/base/Layout");
const Pagination_1 = __importDefault(require("components/base/Pagination"));
const Text_1 = __importDefault(require("components/base/Text"));
const PodcastEpisodePreview_1 = __importDefault(require("components/content/PodcastEpisodePreview"));
const PodcastPreview_1 = __importDefault(require("components/content/PodcastPreview"));
const DynamicFlash_1 = __importDefault(require("components/DynamicFlash"));
const RenderToRoot_1 = __importDefault(require("components/RenderToRoot"));
const CSRFContext_1 = require("contexts/CSRFContext");
const MainLayout_1 = __importDefault(require("layouts/MainLayout"));
const PAGE_SIZE = 24;
const PodcastsPage = ({ loginCallback = '/', episodes, podcasts, lastKey }) => {
    const [items, setItems] = (0, react_1.useState)(episodes);
    const { csrfFetch } = (0, react_1.useContext)(CSRFContext_1.CSRFContext);
    const [currentLastKey, setLastKey] = (0, react_1.useState)(lastKey);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [page, setPage] = react_1.default.useState(0);
    const pageCount = Math.ceil(items.length / PAGE_SIZE);
    const hasMore = !!currentLastKey;
    const fetchMoreData = (0, react_1.useCallback)(async () => {
        setLoading(true);
        const response = await csrfFetch(`/content/getmorepodcasts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                lastKey: currentLastKey,
            }),
        });
        if (response.ok) {
            const json = await response.json();
            if (json.success === 'true') {
                setItems([...items, ...json.episodes]);
                setPage(page + 1);
                setLastKey(json.lastKey);
            }
        }
        setLoading(false);
    }, [items, currentLastKey, page]);
    const pager = (react_1.default.createElement(Pagination_1.default, { count: pageCount, active: page, hasMore: hasMore, onClick: async (newPage) => {
            console.log(newPage, pageCount);
            if (newPage >= pageCount) {
                await fetchMoreData();
            }
            else {
                setPage(newPage);
            }
        }, loading: loading }));
    return (react_1.default.createElement(MainLayout_1.default, { loginCallback: loginCallback },
        react_1.default.createElement(Banner_1.default, null),
        react_1.default.createElement(DynamicFlash_1.default, null),
        react_1.default.createElement(Card_1.Card, { className: "my-3" },
            react_1.default.createElement(Card_1.CardHeader, null,
                react_1.default.createElement(Text_1.default, { md: true, semibold: true }, "Podcasts")),
            react_1.default.createElement(Card_1.CardBody, null,
                react_1.default.createElement(Layout_1.Row, null, podcasts.map((podcast) => (react_1.default.createElement(Layout_1.Col, { key: podcast.id, xs: 12, sm: 6, lg: 3 },
                    react_1.default.createElement(PodcastPreview_1.default, { podcast: podcast }))))))),
        react_1.default.createElement(Card_1.Card, { className: "my-3" },
            react_1.default.createElement(Card_1.CardHeader, null,
                react_1.default.createElement(Layout_1.Flexbox, { direction: "row", justify: "between", alignItems: "center", className: "w-full" },
                    react_1.default.createElement(Text_1.default, { lg: true, semibold: true },
                        "Blog Posts (",
                        items.length,
                        hasMore ? '+' : '',
                        ")"),
                    pager)),
            react_1.default.createElement(Card_1.CardBody, null,
                react_1.default.createElement(Layout_1.Row, null, items.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE).map((episode) => (react_1.default.createElement(Layout_1.Col, { key: episode.id, className: "mb-3", xs: 6, sm: 4, lg: 3 },
                    react_1.default.createElement(PodcastEpisodePreview_1.default, { episode: episode }))))),
                react_1.default.createElement(Layout_1.Flexbox, { direction: "row", justify: "end", alignItems: "center", className: "w-full" }, pager)))));
};
exports.default = (0, RenderToRoot_1.default)(PodcastsPage);
